/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ai-mate.agent-message.error': 'Recarregar bate-papo',
  'ai-mate.agent-message.error.aup-link-text': 'Política de uso aceitável',
  'ai-mate.agent-message.error.aup-one': 'Não foi possível responder a esse prompt.',
  'ai-mate.agent-message.error.aup-two':
    'Seu prompt pode não estar em conformidade com nosso {link}. Tente um prompt diferente.',
  'ai-mate.agent-message.error.copy-trace-id': 'Copiar ID de rastreamento',
  'ai-mate.agent-message.error.network-error': 'Parece haver um problema de rede.',
  'ai-mate.agent-message.error.resend': 'Reenviar a mensagem',
  'ai-mate.agent-message.error.trace-id': 'ID de rastreamento: {traceId}',
  'ai-mate.agent-picker.dropdown-item.agents-dropdown-group-title': 'Agentes que podem ajudar',
  'ai-mate.agent-picker.dropdown-item.chat-history': 'Histórico de bate-papo',
  'ai-mate.agent-picker.dropdown-item.create': 'Criar agente',
  'ai-mate.agent-picker.dropdown-item.debug-mode': 'Modo de depuração',
  'ai-mate.agent-picker.dropdown-item.get-help': 'Obter ajuda',
  'ai-mate.agent-picker.dropdown-item.list': 'Pesquisar agentes',
  'ai-mate.agent-picker.dropdown-item.submit-feedback': 'Enviar feedback',
  'ai-mate.agent-picker.dropdown-trigger-label': 'Selecionar agente',
  'ai-mate.agent-selector.default-agent-name': 'Bate-papo',
  'ai-mate.browse-agents-view.close-button': 'Fechar visualização dos agentes',
  'ai-mate.browse-agents-view.header-title': 'Pesquisar agentes',
  'ai-mate.chat-history.conversationLimit':
    'Procurando uma conversa antiga? Os históricos do chat são apagados após 30 dias para não atrapalhar o funcionamento do AI.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1':
    'Em quais páginas do Confluence eu contribuí nos últimos tempos?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': 'Encontre todos os tickets do Jira atribuídos a mim.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': 'Qual é a nossa política de viagens?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4':
    'Elabore uma página do Confluence para uma campanha de marketing.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': 'Como posso criar uma linha do tempo do projeto?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6':
    'Escreva um e-mail de acompanhamento para clientes em potencial.',
  'ai-mate.chat-history.empty-state.brand-name': 'Bate-papo',
  'ai-mate.chat-history.empty-state.browse-agents-button-label': 'Pesquisar agentes',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': 'Pesquisar agentes',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': 'Converse com um Agente Rovo',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': 'Sobre este espaço',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': 'Insights sobre este espaço',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': 'Sugestão do espaço',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1':
    'Ocorreu alguma atividade nova em páginas escritas por mim?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10': '“Pessoa” comentou em alguma página que eu publiquei?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': 'Quais são as principais conclusões da página?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': 'Há comentários novos que me mencionam?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3':
    'Resuma as páginas publicadas mais recentes neste espaço.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4':
    'Resuma minhas contribuições às páginas na semana passada.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5':
    'Você pode pegar esta "página" e reescrever de maneira menos técnica?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6':
    'Crie um template de plano de jogo para gestão de projetos.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7':
    'Quais pesquisas a gente tem sobre problemas comuns do cliente?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8':
    'Alguém da minha equipe publicou páginas novas esta semana?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': '"Pessoa" publicou páginas novas esta semana?',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion1':
    'Ocorreu alguma atividade nova em páginas escritas por mim?',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion2': 'Há comentários novos que me mencionam?',
  'ai-mate.chat-history.empty-state.confluence-home.suggestion3':
    'Resumir as páginas publicadas mais recentes neste espaço',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': 'Você pode melhorar o texto desta página?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': 'Escreva um resumo executivo para esta página.',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': 'Mostre links para outras páginas relevantes.',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion1': 'Você pode melhorar o texto desta página?',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion2': 'Escreva um resumo executivo para esta página.',
  'ai-mate.chat-history.empty-state.confluence-page-edit.suggestion3': 'Mostre links para outras páginas relevantes.',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': 'Sobre esta página',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': 'Mais sobre esta página',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': 'Sugestão de página',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': 'Resuma o que está sendo exibido.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': 'Resuma os comentários nesta página.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3':
    'Explique esta página para mim como se eu fosse um iniciante.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4':
    'Quem escreveu esta página e de qual equipe esta pessoa é?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5':
    'Houve alguma alteração nesta página na última semana?',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion1': 'Resuma o que está sendo exibido.',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion2':
    'Houve alguma alteração nesta página na última semana?',
  'ai-mate.chat-history.empty-state.confluence-page-view.suggestion3': 'Resuma os comentários nesta página.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': 'Saiba mais sobre este quadro branco',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': 'Mais informações sobre este quadro branco',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': 'Informações sobre este quadro branco',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': 'Resuma o que está sendo exibido.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2':
    'Destaque todos os padrões ou tendências visíveis aqui.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3':
    'Identifique os principais itens de ação ou decisões reunidos neste quadro branco.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion1': 'Resuma o que está sendo exibido.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion2':
    'Destaque todos os padrões ou tendências visíveis aqui.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.suggestion3':
    'Identifique os principais itens de ação ou decisões reunidos neste quadro branco.',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': 'Seja produtivo',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': 'Faça um rascunho do conteúdo',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': 'Encontre informações',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': 'Encontrar pessoas',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': 'Obtenha respostas',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': 'Meça a produtividade',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': 'Reescreva conteúdos',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': 'Fique atualizado',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': 'Resuma conteúdos',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>por</text> {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': 'Oi, {userName}',
  'ai-mate.chat-history.empty-state.intro-text-link-text': 'Descubra o Chat Rovo e os agentes',
  'ai-mate.chat-history.empty-state.intro-text-subheadline':
    'Escolha um ponto de partida para uma conversa ou pergunte qualquer coisa.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': 'Encontre os itens do Jira que foram atualizados esta semana.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh':
    'Encontre os tickets do Jira que foram atualizados esta semana.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': 'Quais itens do Jira têm prioridade mais alta?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh':
    'Quais tickets do Jira têm prioridade mais alta?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': 'Quais itens do Jira têm comentários que me mencionam?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh':
    'Quais tickets do Jira têm comentários que me mencionam?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': 'Resuma os comentários em "item do Jira".',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh':
    'Resuma os comentários em "ticket do Jira".',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': 'Crie um template de descrição para histórias do usuário.',
  'ai-mate.chat-history.empty-state.jira-home.suggestion1':
    'Encontre os itens do Jira que foram atualizados esta semana.',
  'ai-mate.chat-history.empty-state.jira-home.suggestion1-issue-term-refresh':
    'Encontre os tickets do Jira que foram atualizados esta semana.',
  'ai-mate.chat-history.empty-state.jira-home.suggestion2': 'Que itens têm prioridade mais alta?',
  'ai-mate.chat-history.empty-state.jira-home.suggestion2-issue-term-refresh': 'Que tickets têm prioridade mais alta?',
  'ai-mate.chat-history.empty-state.jira-home.suggestion3': 'Que itens têm comentários que me mencionam?',
  'ai-mate.chat-history.empty-state.jira-home.suggestion3-issue-term-refresh':
    'Quais tickets têm comentários que me mencionam?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion1': 'Que itens não têm um responsável?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion1-issue-term-refresh':
    'Que tickets não têm um responsável?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion2': 'Que itens estão em aberto há mais tempo?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion2-issue-term-refresh':
    'Quais tickets estão abertos a mais tempo?',
  'ai-mate.chat-history.empty-state.jira-issue-list.suggestion3': 'Quem tem mais tarefas?',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': 'Sobre este item',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': 'Sobre este ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': 'Mais sobre este item',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': 'Mais sobre este ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': 'Insights neste item',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': 'Insights neste ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': 'Sugestão de item',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': 'Sugestão de ticket',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': 'Há itens do Jira parecidos com este?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh':
    'Há tickets do Jira parecidos com este?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': 'Como melhorar a descrição?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': 'Que etiquetas posso adicionar a esse item?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh':
    'Que etiquetas posso adicionar a esse ticket?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion1': 'Há itens do Jira parecidos com este?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion1-issue-term-refresh':
    'Há tickets do Jira parecidos com este?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion2': 'Como melhorar a descrição?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion3': 'Que etiquetas posso adicionar a esse item?',
  'ai-mate.chat-history.empty-state.jira-issue-view.suggestion3-issue-term-refresh':
    'Que etiquetas posso adicionar a esse ticket?',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': 'Sobre este projeto',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': 'Insights sobre este projeto',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': 'Mais sobre este projeto',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': 'Sugestão de projeto',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': 'Qual ticket não é trabalhado há algum tempo?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': 'Encontre e agrupe itens semelhantes do Jira.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh':
    'Encontre e agrupe tickets semelhantes do Jira.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11': 'Há itens do Jira não conectados a um item pai?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    'Há tickets do Jira não conectados a um ticket pai?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12':
    'Pegue a descrição de "item do Jira" e faça a adequação dela com as práticas recomendadas.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    'Pegue a descrição do "ticket do Jira" e faça a adequação dela com as práticas recomendadas.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': 'Resuma os comentários em "item do Jira".',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    'Resuma os comentários em "ticket do Jira".',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': 'Crie um template de descrição para histórias do usuário.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh':
    'Crie um template de descrição para histórias do usuário.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': 'Há itens do Jira bloqueados?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh': 'Há tickets do Jira bloqueados?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    'Liste e agrupe por responsável os itens do Jira que estão com o status "Fazendo".',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    'Liste e agrupe por responsável os tickets do Jira que estão com o status "Fazendo".',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': 'Quantos itens estão atribuídos a "pessoa"?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh':
    'Quantos tickets estão atribuídos a `person`?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5': '"Pessoa" comentou em itens do Jira neste sprint?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    '"Pessoa" comentou em tickets do Jira neste sprint?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': 'Quais itens do Jira não foram atribuídos?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh':
    'Quais tickets do Jira não foram atribuídos?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': 'Quais itens do Jira estão abertos há mais tempo?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    'Quais tickets do Jira estão abertos há mais tempo?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': 'Quem tem mais tarefas?',
  'ai-mate.chat-history.empty-state.message': 'Obtenha respostas, gere novas ideias e acelere o trabalho diário.',
  'ai-mate.chat-history.empty-state.suggestion1': 'Algum dos tickets está atrasado?',
  'ai-mate.chat-history.empty-state.suggestion2': 'No que devo trabalhar em seguida?',
  'ai-mate.chat-history.empty-state.suggestion3': 'Escrever atualização sobre minha semana',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': 'Sugestão',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'Cancelar',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': 'Confirmar',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button': 'Ocorreu um problema ao concluir esta ação',
  'ai-mate.chat-input.actions-button.label': 'Inserir elementos',
  'ai-mate.chat-input.add-a-link-button.label': 'Adicionar link',
  'ai-mate.chat-input.deleted-agent-icon-label': 'Agente excluído',
  'ai-mate.chat-input.deleted-agent-start-new-chat': 'Iniciar novo bate-papo',
  'ai-mate.chat-input.deleted-agent-warning': 'Este agente foi excluído.',
  'ai-mate.chat-input.drag-and-drop-message': 'Arraste e solte para adicionar contexto e conseguir melhores resultados',
  'ai-mate.chat-input.file-close-icon-label': 'Remover arquivo',
  'ai-mate.chat-input.mention-someone-button.label': 'Mencione alguém ou uma equipe',
  'ai-mate.chat-input.placeholder': 'Escreva um prompt para começar',
  'ai-mate.chat-input.send-button.label': 'Enviar',
  'ai-mate.chat-input.stop-generating-button.label': 'Parar de gerar',
  'ai-mate.chat-input.store-user-messages.label':
    'Registre essa mensagem para ajudar a melhorar a qualidade da resposta',
  'ai-mate.chat-main-header.back-button.label': 'Voltar',
  'ai-mate.chat-main-header.copy-agent-link-button.label': 'Copiar link',
  'ai-mate.chat-main-header.default-agent-name': 'Bate-papo',
  'ai-mate.chat-main-header.edit-agent-button.label': 'Editar',
  'ai-mate.chat-main-header.link-copied-to-profile': 'URL copiada',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Excluir',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Renomear',
  'ai-mate.chat-view.chat-item.options-button-label': 'Opções de bate-papo',
  'ai-mate.content-renderer.profile-card.view-profile-button': 'Visualizar perfil',
  'ai-mate.content-renderer.view-code-button-label': 'Exibir análise',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Cancelar',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'A conversa que você está tentando excluir não existe.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Excluir',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Excluir conversa "{name}"?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Ocorreu um erro ao excluir a conversa. Tente de novo.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Tem certeza de que quer excluir essa conversa? A ação não pode ser desfeita.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Cancelar',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'O canal que você está tentando editar não existe.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Nome',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Ocorreu um erro ao editar a conversa. Tente de novo.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Editar conversa',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'O nome é o mesmo que o nome atual.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Salvar',
  'ai-mate.conversation-list-view.back-button.label': 'Voltar',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Fechar bate-papo',
  'ai-mate.conversation-list-view.header-title': 'Histórico de bate-papo',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Novo bate-papo',
  'ai-mate.conversation-list-view.no-chat': 'Sem resultados',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Pesquisar bate-papos',
  'ai-mate.expander.hide-details': 'Ocultar informações',
  'ai-mate.expander.show-details': 'Mostrar mais informações',
  'ai-mate.footer.beta': 'BETA',
  'ai-mate.footer.info': 'A qualidade do conteúdo pode variar',
  'ai-mate.footer.info-truncated': 'A qualidade do conteúdo pode variar',
  'ai-mate.footer.info-updated': 'O conteúdo é baseado nas permissões e a qualidade pode variar',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.main-chat.close-chat-button-label': 'Fechar',
  'ai-mate.main-chat.maximize-chat-button-label': 'Tela cheia',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restaurar visualização',
  'ai-mate.main-chat.new-chat-button-label': 'Novo',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Novo bate-papo',
  'ai-mate.main-panel.failed-to-load-agents': 'Não foi possível encontrar agentes',
  'ai-mate.message-renderer.error': 'Avise a gente se o problema continua.',
  'ai-mate.message-renderer.error-title': 'Falha ao carregar o conteúdo',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': 'Falha na confirmação. Tente de novo em alguns instantes.',
  'ai-mate.pubsub-listener.forge-auth-success-message': 'Confirmação bem-sucedida, reenvie seu prompt.',
  'ai-mate.sidebar.agents-icon.text': 'Agentes',
  'ai-mate.sidebar.agents-icon.tooltip': 'Navegue pelos agentes Rovo',
  'ai-mate.sidebar.chat-icon.text': 'Bate-papo',
  'ai-mate.sidebar.chat-icon.tooltip': 'Converse com o Rovo',
  'ai-mate.sidebar.debug-mode-icon.tooltip': 'Depurar',
  'ai-mate.sidebar.get-help-icon.tooltip': 'Obter ajuda',
  'ai-mate.sidebar.give-feedback-icon.tooltip': 'Enviar feedback',
  'ai-mate.sidebar.history-icon.text': 'Histórico',
  'ai-mate.sidebar.history-icon.tooltip': 'Ver seu histórico de bate-papo',
  'chat-history.rate-limit-warning':
    '{secondsRemaining, plural, one {Aguarde {secondsRemaining,number} segundo} other {Aguarde {secondsRemaining,number} segundos}}',
  'chat-history.rate-limit-warning-description': 'As mensagens estão sendo enviadas muito rápido, aguarde.',
  'chatHistory.storeAssistant.badResponseLabel': 'Resposta ruim',
  'chatHistory.storeAssistant.copyResponseLabel': 'Copiar',
  'chatHistory.storeAssistant.goodResponseLabel': 'Boa resposta',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': 'Usar esse contexto',
  'rovo-chat.data-sculptor-modal.cancel': 'Cancelar',
  'rovo-chat.data-sculptor-modal.title': 'Análise',
  'rovo-chat.file-upload-button.label': 'Carregar ficheiro',
  'rovo-chat.file-upload-button.max-files-label':
    '{maxFiles, plural, one {Limite de {maxFiles,number} arquivo atingido} other {Limite de {maxFiles,number} arquivos atingido}}',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Arraste e solte para adicionar contexto',
  'rovo-chat.message-file.icon-label': 'Arquivo',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': 'Inserir na página',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': 'Inserir',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': 'Inserir no item',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': 'Substituir seleção',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    'Essa função não é compatível no seu contexto atual. Tente selecionar, escrever ou editar o texto na página.',
};
